import React from 'react';
import { useCallback, useState } from 'react';
import type { AttachedFile } from '../types/support';

const MAX_FILES = 10;
const MAX_SIZE = 20 * 1024 * 1024;

export interface AddResult {
    added: number;
    tooBig: number;
    duplicate: number;
}


export function useAttachments() {
    const [files, setFiles] = useState<AttachedFile[]>([]);

    const add = useCallback(
        (incoming: FileList | File[]): AddResult => {
            const result: AddResult = { added: 0, tooBig: 0, duplicate: 0};
            const merged = [...files];

            Array.from(incoming).forEach((file) => {
                if (file.size > MAX_SIZE) return void result.tooBig++;

                const id = `${file.name}-${file.size}-${file.lastModified}`;
                if (merged.some((f) => f.id === id)) return void result.duplicate++;

                merged.push({ id, name: file.name, size: file.size, file } as AttachedFile);
                result.added++;
            });

            if (result.added) setFiles(merged);
            return result;
        },
        [files],
    );

    const remove = useCallback((id: string) => {
        setFiles((prev) => prev.filter((file) => file.id !== id));
    }, []);

    const clear = useCallback(() => setFiles([]), []);

    return {
        files,
        add,
        remove,
        clear,
        addFiles: add,
        removeFile: remove,
        resetFiles: clear,
    };
}